import { styled } from '../../../utils/styled';
import { propStyles } from '../../../utils/propStyles';

const StyledComponent = styled<any, any>('button', 'modalCloseButton', 'modal')`
    ${propStyles};
`;

StyledComponent.defaultProps = {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'row',
    border: 'none',
    background: 'none',
    cursor: 'pointer',
};

export default StyledComponent;



// WEBPACK FOOTER //
// ./src/Components/Modal/StyledComponents/ModalCloseButton.tsx